import {
  SxProps,
  inputBaseClasses,
  menuItemClasses,
  outlinedInputClasses,
  selectClasses,
  typographyClasses,
} from '@mui/material'
import { filterDropdownIconStyles } from './FilterDropdownIcon'
import { filterDropdownClasses } from './FilterDropdown.data'

interface FilterDropdownStyles {
  formControl: SxProps
  select: SxProps
  menuList: SxProps
  listItemText: SxProps
  checkIcon: SxProps
  dropdownOptions: SxProps
}

const notchedOutlineStyles: Record<string, SxProps> = {
  [`.${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'utils.gray200',
  },
  [`&.${selectClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'utils.gray300',
  },
  [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'utils.gray300',
  },
  [`&.${selectClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'utils.blue200',
  },
  [`&.${filterDropdownClasses.active} > .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'utils.blue200',
  },
  [`&.${filterDropdownClasses.active}:hover > .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'utils.blue200',
  },
}

export const filterDropdownStyles: FilterDropdownStyles = {
  formControl: { minWidth: 'auto' },
  select: {
    px: 0.5,
    borderRadius: 12,
    width: '100%',
    height: '100%',
    [`.${selectClasses.select}`]: {
      display: 'flex',
      alignItems: 'center',
    },
    [`.${inputBaseClasses.input}.${selectClasses.select}.${outlinedInputClasses.input}`]: {
      padding: '2px 6px 2px 8px',
    },

    [`&:hover:not(.${filterDropdownClasses.active}, .${selectClasses.focused})`]: {
      backgroundColor: 'utils.gray200',
      [`.${typographyClasses.root}`]: {
        color: 'utils.gray800',
      },
    },
    [`&.${selectClasses.focused}`]: {
      backgroundColor: 'brand.utility50',
    },

    [`&.${filterDropdownClasses.active}`]: {
      backgroundColor: 'brand.utility50',
    },
    ...notchedOutlineStyles,
    ...filterDropdownIconStyles,
  },

  menuList: {
    pt: 0,
    pb: 0,
    [`.${menuItemClasses.root}`]: {
      px: 1.25,
      py: 1,
      borderRadius: 1.5,
      display: 'flex',
      justifyContent: 'space-between',
      gap: 1,
      '&.Mui-focusVisible': {
        backgroundColor: 'transparent',
      },
      '&:hover': {
        backgroundColor: 'utils.gray50',
      },
      '&.Mui-selected': {
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  listItemText: {
    typography: 'textXsSemibold',
    color: 'utils.gray700',
    [`&.${filterDropdownClasses.selectedValue}`]: {
      color: `text.hyperLink`,
    },
  },
  checkIcon: {
    width: 15,
    visibility: 'hidden',
    [`&.${filterDropdownClasses.selectedValue}`]: {
      color: `text.hyperLink`,
      visibility: 'visible',
    },
  },

  dropdownOptions: {
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'utils.gray200',
    mt: 0.5,
    px: 1,
    py: 0.75,
    boxShadow:
      '0px 12px 16px -4px rgba(10, 13, 18, 0.08), 0px 4px 6px -2px rgba(10, 13, 18, 0.03), 0px 2px 2px -1px rgba(10, 13, 18, 0.04)',
    maxHeight: 200,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'utils.gray300',
      borderRadius: '4px',
      opacity: 0.15,
      border: '1px solid',
      borderColor: 'background.default',
    },
    '&::-webkit-scrollbar-button': {
      display: 'inline-block',
    },
  },
}
